import React from "react";
import CollegeFormContainer from "../Container/CollegeFormContainer";
// import AccountFormCommon from "./AccountFormCommon";
import TeacherAccountForm from "./TeacherAccountForm";
import { connect } from "react-redux";
import { API } from "../../API"
import { notify } from "react-notify-toast"
import UploadAvatarPersonnel from "../Home/UploadAvatarPersonnel"
import { updateUserDetails } from "../../redux/college/college.actions"
import { permIndices } from '../../Permissions'

class PersonnelAccount extends React.Component {
  state = {
    current_password: "",
    new_password: "",
    confirm_password: "",
    show_password_current: false,
    show_password_new: false,
    show_password_confirm: false,
    // password_strength: "",
    check_password: [],
    secret_question1: "",
    secret_question2: "",
    secret_answer1: "",
    secret_answer2: "",
    subscribe_newsletter: false,
    subscribe_updates: false,
    isUploadPopup: false
  }

  toggleUploadPopup = (bool) => {
    this.setState({ isUploadPopup: bool })
  }

  setUser = (user) => {
    // this.setState({ user: user })
  }

  handleStateChange = (key, value) => {
    this.setState({ [key]: value })
  }

  handleFormFieldChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

  handleCheckboxChange = (e) => {
    this.setState({ [e.target.id]: e.target.checked })
  }

  onSubmit = (e) => {
    e.preventDefault();

    const fields = [
      "current_password",
      "confirm_password", //only required if new_password is entered
      //secret question/answer fields must be entered all at once
      "secret_question1",
      "secret_answer1",
      "secret_question2",
      "secret_answer2"
    ]
    let errors = false

    for (let field of fields) {
      const input = document.getElementById(field);
      if (!input.reportValidity()) {
        errors = true;
        break;
      }
    }

    if (!errors) {
      console.log("personnel:::", this.props.user.personnel_id)
      const user = {
        id: this.props.user.personnel_id,
        role: "personnel",
        password: this.state.current_password,
      }
      API.confirmPassword({ user: user })
        .then(async (res) => { // if current password is correct
          let success = false;
          let error = false;
          let errorMessage = "No new settings have been entered.";
          if (this.state.new_password) {
            const password_strength = document.querySelector("progress").value; // find a better way to do this?
            if (password_strength >= 2) {
              if (this.state.new_password === this.state.confirm_password) {
                await API.changePassword({
                  user: {
                    ...user,
                    newPassword: this.state.new_password
                  },
                })
                .then(res => {
                  success = true;
                })
                .catch(err => {
                  console.log(err)
                  error = true;
                  errorMessage = "Error updating password.";
                })
              } else {
                error = true;
                errorMessage = "Passwords do not match."
              }
            } else {
              error = true;
              errorMessage = "Check the required password condition."
            }
          }

          if (!error && (this.state.secret_question1 || this.state.secret_answer2)) {
            await API.changeSecretQAndA({
              user: {
                ...user,
                secret_question1: this.state.secret_question1,
                secret_answer1: this.state.secret_answer1,
                secret_question2: this.state.secret_question2,
                secret_answer2: this.state.secret_answer2,
              }
            })
              .then(res => {
                success = true;
              })
              .catch(err => {
                console.log(err)
                error = true;
                errorMessage = "Error updating secret questions.";
              })
          }

          if (success) {
            notify.show("Account settings updated successfully.")
          }
          else {
            notify.show(errorMessage, "error")
          }
        })
        .catch((err) => { // if current password is incorrect
          console.log('wrong current password');
          notify.show("Current password is incorrect", "error")
          console.log(err)
        })
    }
  }

  render() {
    return (
      <CollegeFormContainer
        user={this.props.user}
        isShowWhereby={true}
        isShowUploadAvatar={true}
        tabProfileActive={true}
        uploadAvatar={() => this.toggleUploadPopup(true)}
        offset={true}
        header="My Account"
        handleSubmit={this.onSubmit}
        // add new prop for checking personnel - lieh
        isViewAsPersonnel={true}
        viewbookings={this.props.user.permissions & (1 << permIndices.vi_book)}
      >
        {this.state.isUploadPopup && (
          <UploadAvatarPersonnel
            showPopup={this.toggleUploadPopup}
            setUser={this.setUser}
            user={this.props.user}
          />
        )}
        <TeacherAccountForm
          handleStateChange={this.handleStateChange}
          handleFormFieldChange={this.handleFormFieldChange}
          handleCheckboxChange={this.handleCheckboxChange}
          state={this.state}
        />
      </CollegeFormContainer>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.college.user
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateUserDetails: (details) => dispatch(updateUserDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PersonnelAccount);